export default{
    namespaced: true,

    state:{
        areasMedicamentos:[
            {value:1, text:'Gaveta de Quirófano'},
            {value:2, text:'Farmacia'},
            {value:3, text:'Preparacion de medicamentos'},
            {value:5, text:'Carro rojo 1'},
            {value:6, text:'Carro rojo 2'},
            {value:7, text:'Carro rojo 3'},
            {value:8, text:'Gaveta de medicamento controlado'},
            {value:9, text:'Refrigerador'},
        ],
        areasLavadoManos:[
            {value:1, text:'Sótano'},
            {value:2, text:'Baños públicos planta baja'},
            //{value:3, text:'Administración'},
            {value:4, text:'Imagenología'},
            {value:5, text:'Descanso Hombres'},
            {value:6, text:'Descanso Mujeres'},
            {value:7, text:'Encamados 1'},
            {value:8, text:'Encamados 2'},
            {value:9, text:'Central enfermeras 2'},
            {value:10, text:'Planta alta Comedor'},
            {value:11, text:'Endoscopias'},
        ],

        factibilidadSolucion:[
            {value:1, text:'No hay factibilidad de solución'},
            {value:2, text:'Poco factible de solucionar'},
            {value:3, text:'Medianamente factible de solucionar'},
            {value:4, text:'Factible de solucionar'},
            {value:5, text:'Muy factible de solucionar'},
        ],

        probabilidadOcurrencia:[
            {value:1, text:'Sin probabilidad que ocurra'},
            {value:2, text:'Poco probable que ocurra'},
            {value:3, text:'Medianamente probable que ocurra'},
            {value:4, text:'Muy probable que ocurra'},
            {value:5, text:'Es seguro que ocurra'},
        ],

        impacto:[
            {value:1, text:'Sin impacto'},
            {value:2, text:'Impacto leve'},
            {value:3, text:'Impacto regular'},
            {value:4, text:'Impacto grave'},
            {value:5, text:'Impacto muy grave'},
        ],
        indicadoresDatos:{
            1:{
                tab: "AESP 1",
                nombre:'Identificación del paciente',
                descripcion:'Mejorar la precisión de la identificación de pacientes, unificando este proceso en los establecimientos del Sector Salud, utilizando al menos dos datos que permitan prevenir errores que involucran al paciente equivocado.',
            },
            2:{
                tab: "AESP 2",
                nombre:'Comunicación Efectiva',
                descripcion:'Mejorar la comunicación entre los profesionales de la salud, pacientes y familiares, a fin de obtener información correcta, oportuna y completa durante el proceso de atención y así, reducir los errores relacionados con la emisión de órdenes verbales o telefónicas.',
            },
            3:{
                tab: "AESP 3",
                nombre:'Seguridad en el proceso de medicación',
                descripcion:'Fortalecer las acciones relacionadas con el almacenamiento, la prescripción, transcripción, dispensación y administración de medicamentos, para prevenir errores que puedan dañar a los pacientes.',
            },
            4:{
                tab: "AESP 4",
                nombre:'Seguridad en los procedimientos',
                descripcion:'Reforzar las prácticas de seguridad ya aceptadas internacionalmente y reducir los eventos adversos para evitar la presencia de eventos centinela derivados de la práctica quirúrgica y procedimientos de alto riesgo fuera del quirófano.',
            },
            5:{
                tab: "AESP 5",
                nombre:'Reducción del riesgo de Infecciones Asociadas a la Atención de la Salud (IAAS)',
                descripcion:'Coadyuvar a reducir las IAAS, a través de la implementación de un programa integral de higiene de manos durante el proceso de atención.',
            },
            6:{
                tab: "AESP 6",
                nombre:'Reducción del riesgo de daño al paciente por causa de caídas',
                descripcion:'Prevenir el daño al paciente asociado a las caídas en los establecimientos de atención médica del Sistema Nacional de Salud mediante la evaluación y reducción del riesgo de caídas.',
            },

            7:{
                tab: "PCI",
                nombre:'Prevención y Control de Infecciones',
                descripcion:'Acciones específicas con enfoque multidisciplinario en toda la organización para reducir el riesgo de infección en pacientes',
            },
            8:{
                tab: "SQE",
                nombre:'Competencias y Capacitación del Personal',
                descripcion:'Prevenir el daño al paciente asociado a las caídas en los establecimientos de atención médica del Sistema Nacional de Salud mediante la evaluación y reducción del riesgo de caídas.',
            },
            9:{
                tab: "FMS",
                nombre:'Gestión y Seguridad de las Instalaciones',
                descripcion:'La seguridad de las instalaciones es guiada por procesos acordes a la legislación aplicable vigente.',
            },
            10:{
                tab: "AOP",
                nombre:'Evaluación de pacientes',
                descripcion:'Procesos para la evaluación y re evaluación de estado y necesidades de los pacientes',
            },
            11:{
                tab: "MMU",
                nombre:'Manejo y Uso de los Medicamentos',
                descripcion:'Procesos de manejo y uso de los medicamentos',
            },
            12:{
                tab: "GLD",
                nombre:'Gobierno, liderazgo y dirección',
                descripcion:'Responsabilidades y evaluación del desempeño del gobierno de la organización.',
            },

            13:{
                tab: "MCI",
                nombre:'Gestión de la Comunicación y la Información',
                descripcion:'Se planean y diseñan procesos para gestionar la información que genera la organización.',
            },

        },


        indicadores:{
            1:[
                // AESP1
                {id:101, name:"Datos de identificación", url:'datosid', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 10},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 8},
                    ]
                },
                {id:102, name:"Identificación en hospital", url:'datoshospital', total: 0,parametros: [
                        {etiqueta:'Evaluaciones', valor: 15},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 7.5},
                    ]
                },
            ],
            2:[
                {id:201, name:"Comunicación efectiva", url:'', total: 0,parametros: [
                    {etiqueta:'Evaluaciones', valor: 0},
                    {etiqueta:'Máximo', valor: 10},
                    {etiqueta:'Mínimo', valor: 7.5},
                ]
            },
            ],
            3:[
                // AESP3
                {id:301, name:"Medicamentos de alto riesgo", url:'medAr', total: 0, parametros: [
                        {etiqueta:'Internamientos', valor: 320},
                        {etiqueta:'Incidentes', valor: 5},
                    ]
                },
                {id:302, name:"Identificación medicamentos", url:'idMedicamentos', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 14},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 9.5},
                    ]
                },

                {id:303, name:"Incidentes de medicamentos", url:'irspMed', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 14},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 9.5},
                    ]
                },

                /*
                {id:303, name:"Carro de paro", url:'carroRojo', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 14},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 9.5},
                    ]
                },
                */
            ],
            4:[
                // AESP4
                {id:401, name:"Cirugía segura", url:'cirugiaSegura', total: 0, parametros: [
                        {etiqueta:'Verificados', valor: 320},
                        {etiqueta:'Lista completa', valor: 318},
                    ]
                },
            ],
            5:[
                // AESP5
                {id:501, name:"Insumos para lavado", url:'insumoslavado', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 10},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 8},
                    ]
                },
                {id:502, name:"Cinco momentos", url:'cincomomentos', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 10},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 8},
                    ]
                },
                {id:503, name:"Técnica de lavado", url:'lavadomanos', total: 0, parametros: [
                        {etiqueta:'Evaluaciones', valor: 10},
                        {etiqueta:'Máximo', valor: 10},
                        {etiqueta:'Mínimo', valor: 8},
                    ]
                },
            ],
            6:[
                // AESP6
                {id:601, name:"Pacientes sin caidas", url:'caidasPacientes', total: 0, parametros: [
                        {etiqueta:'Internamientos', valor: 320},
                        {etiqueta:'Reportados', valor: 8},

                    ]
                },
                {id:602, name:"Acciones para prevenir caidas", url:'prevcaidas', total: 0, parametros: [
                        {etiqueta:'Analizados', valor: 120},
                        {etiqueta:'Riesgo bajo', valor: '84/85'},
                        {etiqueta:'Riesgo medio', valor: '20/20'},
                        {etiqueta:'Riesgo alto', valor: '8/15'},

                    ]
                },
            ],
            7:[
                // PCI
                {id:701, name:"Infecciones nosocomiales", url:'', total: 0, parametros: []
                },
                {id:702, name:"Apego a la higiene de manos", url:'', total: 0, parametros: []
                },
            ],
            8:[
                // SQE
                {id:801, name:"Inducción al puesto al personal", url:'', total: 0, parametros: []
                },
                {id:802, name:"Salud y seguridad en el trabajo", url:'', total: 0, parametros: []
                },
            ],
            9:[
                // FMS
                {id:901, name:"Inspeccionar las instalaciones del CASF", url:'matrizRiesgos', total: 0, parametros: [
                    {etiqueta:'Internamientos', valor: 320},
                    {etiqueta:'Reportados', valor: 8},

                    ]
                },
                {id:902, name:"Respuesta de equipo biomedico", url:'biomedicaTiempos', total: 0, parametros: [
                    {etiqueta:'Internamientos', valor: 320},
                    {etiqueta:'Reportados', valor: 8},
                    ]
                },
                {id:903, name:"Mantenimientos programados", url:'biomedicaPreventivos', total: 0, parametros: [
                    {etiqueta:'Internamientos', valor: 320},
                    {etiqueta:'Reportados', valor: 8},
                    ]
                },
            ],
            10:[
                // AOP
                {id:1001, name:"Cumplimiento de valoraciones", url:'valoracionesRealizadas', total: 0, parametros: []},
                {id:1002, name:"Valoraciones nuevas", url:'valoracionesRealizadasTiempo', total: 0, parametros: []},
            ],
            11:[
                // MMU
                {id:1101, name:"Uso de frascos multidosis", url:'', total: 0, parametros: []
                },
                {id:1102, name:"Frascos multidosis usados", url:'', total: 0, parametros: []
                },
                {id:1103, name:"Carro de Soporte Vital Avanzado", url:'carroRojo', total: 0, parametros: [
                    {etiqueta:'Evaluaciones', valor: 14},
                    {etiqueta:'Máximo', valor: 10},
                    {etiqueta:'Mínimo', valor: 9.5},
                    ]
                },
            ],
            12:[
                // GLD
                {id:1201, name:"Satisfacción de usuarios", url:'satisfaccionUsuarios', total: 0, parametros: [
                    {etiqueta:'Internamientos', valor: 320},
                    {etiqueta:'Reportados', valor: 8},

                    ]
                },
            ],
            13:[
                // MCI
                {id:1301, name:"Evaluación del Expediente Clínico", url:'expClinico', total: 0, parametros: [
                    {etiqueta:'Internamientos', valor: 320},
                    {etiqueta:'Reportados', valor: 8},

                    ]
                },
            ],

        },

        mesResumen:'',
        tabResumen:0,

    },
    mutations:{
//        CAMBIA_FECHA(state, data){
//            state.fecha = data
//        },
        CAMBIA_MES(state, data){
            //console.log('cambindo con '+data)
            state.mesResumen = data
        },
        CAMBIA_TAB_RESUMEN(state, data){
            state.tabResumen = data
        },
    },
    actions:{
        //
    },
    getters:{
        //
    },
}